import { useState } from "react"

type Props = {
	selectionChange: (option: string) => void
}

export function Background({ onLoaded }: { onLoaded: boolean }) {
	return <div id="background" className={`${onLoaded ? "fade" : ""}`}></div>
}

export function Logo() {
	function openPunkOffice() {
		window.open("https://punkoffice.com", "_blank")
	}

	return (
		<div id="createdBy" onClick={openPunkOffice}>
			Built by <img alt="Punk Office logo" src="assets/punkoffice.svg" />
		</div>
	)
}

export function CamereView({ selectionChange }: Props) {
	function changed(e: any) {
		selectionChange(e.target.defaultValue)
		e.target.blur()
	}

	return (
		<div id="cameraView">
			<div>
				<label>
					<input
						id="topRadio"
						type="radio"
						name="radio"
						value="top"
						onChange={changed}
						defaultChecked
					/>
					<span>Top-view</span>
				</label>
				<label>
					<input
						id="thirdRadio"
						type="radio"
						name="radio"
						value="third"
						onChange={changed}
					/>
					<span>Third person</span>
				</label>
				<label>
					<input
						id="stationaryRadio"
						type="radio"
						name="radio"
						value="stationary"
						onChange={changed}
					/>
					<span>Stationary</span>
				</label>
			</div>
		</div>
	)
}

export function Instructions() {
	const iconSrc = "assets/CloseButton.svg" // Initial icon path
	const [isVisible, setIsVisible] = useState(true)

	// Function to toggle visibility
	const toggleVisibility = () => {
		setIsVisible(!isVisible)
	}

	return (
		<>
			{isVisible && (
				<div id="instructions">
					<h1 id="instructionsHeading">How to Control & Customise</h1>
					<button id="closeButton">
						<img
							src={iconSrc}
							alt="Top Toggle Icon"
							onClick={toggleVisibility}
							className="closeButtonIcon"
						/>
					</button>
					<p id="instructionsText">
						Move the cat using the arrow or W,A,S,D keys or by dragging with
						your finger. View in different perspectives, upload a fabric
						texture, and change the angle and colour of the hem to meet your
						needs.
					</p>
					<table>
						<tbody>
							<tr>
								<td>W,A,S,D or arrow keys</td>
								<td>Move in direction</td>
							</tr>
							<tr>
								<td>SHIFT</td>
								<td>Run while moving</td>
							</tr>
							<tr>
								<td>SPACE</td>
								<td>Go slow while moving</td>
							</tr>
						</tbody>
					</table>
				</div>
			)}
		</>
	)
}

export function Loading() {
	return (
		<div id="loading">
			<div id="loadingText">Loading</div>
			<div className="circle-logo-container">
				<img
					id="loadingLogo"
					alt="Punk Office logo"
					src="assets/punkoffice.svg"
				/>
				<div className="circle-big">
					<svg>
						<circle className="bg" cx="171" cy="171" r="156"></circle>
						<circle
							className="progress"
							id="progressCircle"
							cx="171"
							cy="171"
							r="156"
						></circle>
					</svg>
				</div>
			</div>
		</div>
	)
}
